import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { UsersService } from './users-service.service';
import { ListPayload } from '@product/shared/models/ListPayload';
import { LoginService } from '@app/shared/services/Login.service';
import { Observable, switchMap, tap } from 'rxjs';
import { UserDto } from '../models/user-dto';

@Component({
  selector: 'app-users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.less'],
})
export class UsersManagementComponent extends BaseComponent implements OnInit {
  payload: ListPayload = {
    Filters: {},
    IsAscend: false,
    PageIndex: 0,
    PageSize: 20,
    SortBy: 'Id',
    Attributes: [],
  };
  users: UserDto[] = [];
  constructor(
    injector: Injector,
    private usersService: UsersService,
    private loginService: LoginService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.subscriptions.push(this.getUsers().subscribe());
  }

  getUsers() {
    this.isLoading = true;
    return this.usersService.getUsersList(this.payload).pipe(
      tap((response: any) => {
        this.users = [];
        this.users = response;
        this.isLoading = false;
      })
    );
  }
  getUser() {}

  resetPasswordRequest(email: string) {
    if (email == null) {
      this.message.error("Can't reset passwords for users without emails ");
      return;
    }

    this.subscriptions.push(
      this.loginService
        .sendResetPassRequest(email)
        .pipe(
          tap(() => {
            this.message.success('Reset password Email has been sent');
          })
        )
        .subscribe()
    );
  }

  changeUserActivationStatus(email: string, status: boolean) {
    let obs: Observable<any>;
    if (status) {
      obs = this.usersService.activateUser(email);
    } else {
      obs = this.usersService.deactivateUser(email);
    }

    this.subscriptions.push(
      obs
        .pipe(
          tap(() => {
            const message = status
              ? `User [${email}] activated successfully`
              : `User [${email}] deactivated successfully`;

            this.message.success(message);
          }),
          switchMap(() => this.getUsers())
        )
        .subscribe()
    );
  }
}
